import { cloneElement } from 'react';
import InfoButton from '@/atoms/buttons/InfoButton';
import Divider from '@/atoms/dividers/Divider';
import Heading from '@/atoms/typography/Heading';
import Popover from '@/molecules/modals/Popover/Popover';
import Size from '@enums/Size';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useGlobalModalContext } from '@providers/globalModal/GlobalModalProvider';
import { Position } from '@/lib/enums';
import { brand, core } from '@/lib/theme/tokens/palettes';

const InformationPopover = ({ information }) => {
  return (
    <Popover
      Component={
        <InfoButton
          colorProps={{
            backgroundColor: brand.yellow.main,
            color: core.white,
          }}
          size={Size.X_SMALL}
        />
      }
      position={Position.BOTTOM}
    >
      <Box
        pl={1.5}
        pr={1}
        pt={1}
        pb={0.25}
        sx={{
          boxShadow: `inset 4px 0 0 0 ${brand.yellow.main}`,
        }}
      >
        {information}
      </Box>
    </Popover>
  );
};

const InformationModal = ({ information }) => {
  const { openModal, closeModal } = useGlobalModalContext();

  const handleOpen = () => {
    openModal({
      settings: {
        closeOnEscape: true,
        minHeight: '20vh',
        minWidth: '40vw',
        padding: 0,
        top: '5%',
        transform: 'translate(-50%, -2.5%)',
      },
      content: cloneElement(information, { onClose: closeModal }),
    });
  };
  return (
    <InfoButton
      colorProps={{
        backgroundColor: brand.yellow.main,
        color: core.white,
      }}
      onClick={handleOpen}
      size={Size.X_SMALL}
    />
  );
};

const CardHeader = ({
  action,
  information,
  isInformationModal,
  title,
  isTitleAction,
}) => {
  const justifyContent =
    Boolean(title) && Boolean(action) && !isTitleAction
      ? 'space-between'
      : 'flex-start';

  return (
    (Boolean(title) || Boolean(action)) && (
      <>
        <Stack
          justifyContent={justifyContent}
          alignItems="center"
          direction="row"
          sx={{ px: 1 }}
          spacing={1}
        >
          {Boolean(title) && (
            <Stack alignItems="center" direction="row" py={1}>
              <Heading variant="h3" overrideStyles={{ fontSize: '1rem' }}>
                {title}
              </Heading>
              {Boolean(information) && !isInformationModal && (
                <InformationPopover information={information} />
              )}
              {Boolean(information) && isInformationModal && (
                <InformationModal information={information} />
              )}
            </Stack>
          )}
          {Boolean(action) && <>{action}</>}
        </Stack>
        <Divider color="primary" />
      </>
    )
  );
};

export default CardHeader;
